/** This file is only temporary until consumers can convert to using the sass palette defined in this folder.
 * Make sure that any changes to any colors in this file or in palette.module.scss remain in sync
 */
export const aderantColors = {
    //main colors
    Galaxy: "#1F3C4F",
    Ahsoka: "#5F7286",
    R2D2: "#1379CE",
    Lightsaber: "#D0E4F5",
    //45% opacity of Lightsaber
    Lightsaber45: "#E8F3FB",
    //feedback colors
    Nebula: "#444BAA",
    ANewHope: "#DEDBEE",
    BobaFett: "#047C62",
    Grogu: "#96EBAE",
    Andor: "#D7D9D9",
    JarJarBinks: "#00660C",
    Watto: "#515252",
    Yoda: "#CDE5E0",
    C3PO: "#FDBE03",
    Rey: "#FEECB3",
    BB8: "#DE5D00",
    Tatooine: "#F5CEB3",
    DarthMaul: "#C20027",
    Sith: "#F3CCD2",
    //shades
    DarthVader: "#000000",
    DarthVaderAlt: "#333333",
    Skywalker: "#2C3539",
    Mandalorian: "#434F56",
    DeathStar: "#5C6B75",
    TIEFighter: "#BEC4CA",
    MillenniumFalcon: "#D8DBDF",
    Tauntaun: "#EEEFF1",
    Leia: "#FAFAFB",
    Stormtrooper: "#FFFFFF"
};
